/// <reference path="../app.ts" />
namespace Cfnc {
    interface IImportantMessageModalScope extends ng.IScope {
        close: () => void;
        messages: Array<string>;
    }

    interface IImportantMessageModal {

    }

    class ImportantMessageModal implements IImportantMessageModal {
        static controllerId: string = "importantMessageModal";

        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, private common: ICommonFactory, private $scope: IImportantMessageModalScope) {
            $scope.close = () => this.close();
            $scope.messages = [];
            this.getMessages();
        }

        close() {
            this.$uibModalInstance.dismiss();
        }

        getMessages() {
            //this.$scope.messages.push("If you graduated in summer 2012 or before, you will need to contact your high school directly to request a transcript. Please note this is a temporary process change for electronic transcripts until NC DPI migrates historical data from NC WISE to PowerSchool.");
        }
    }

    angular.module("app").controller(ImportantMessageModal.controllerId, ["$uibModalInstance", "common", "$scope", ($uibModal: ng.ui.bootstrap.IModalServiceInstance, common: ICommonFactory, $scope) =>
        new ImportantMessageModal($uibModal, common, $scope)
    ]);
}